import { PopupActions } from "@store/popupStore";

const copyToClipboard = (text: null | string, textType: string) => {
  if (!text) {
    PopupActions.openAlert({
      duration: 4000,
      message: "No text to copy.",
      severity: "error",
    });
    return;
  }

  navigator.clipboard.writeText(text).then(() => {
    PopupActions.openAlert({
      duration: 4000,
      message: `${textType} copied to clipboard.`,
      severity: "success",
    });
  });
};

export default copyToClipboard;
